import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import Goal from '../../models/Goal';


export interface GoalDetailState extends ApiState {
  goal?: Goal
}

export default requestReducer<GoalDetailState>('GOAL_DETAIL')
